import { render, staticRenderFns } from "./khjl.vue?vue&type=template&id=d045921e&scoped=true&"
import script from "./khjl.vue?vue&type=script&lang=js&"
export * from "./khjl.vue?vue&type=script&lang=js&"
import style0 from "./khjl.vue?vue&type=style&index=0&id=d045921e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d045921e",
  null
  
)

export default component.exports